import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { paymentsListMock } from 'src/mocks/payments-fake.mock'; 
import { Location } from '@angular/common';


@Component({
  selector: 'app-detail-payment',
  templateUrl: './detail-payment.component.html',
  styleUrls: ['./detail-payment.component.scss']
})
export class DetailPaymentComponent implements OnInit {
  @Input() detailItem!: any ;


  public paymentsData!: any[];
  public paymentDetail: any;
  public locale: Locale = es;
  public selectedState: any | undefined;
  public statesBooking : any | undefined = 'Estado de la reserva'
  public selectColourState: string = '';


  constructor(public route: ActivatedRoute, public location: Location) {}

  ngOnInit() {
      this.paymentsData = paymentsListMock;
      const idPayment = this.route.snapshot.paramMap.get('id');
      if (idPayment) {
        this.paymentDetail = this.getPaymentDetailsById(idPayment);
      }
  }


  getPaymentDetailsById(id: string): any {
      return paymentsListMock.find(payment => payment.id === id);
  }


  formatDate(date: Date): string {
    return format(date, 'EEEE dd  MMMM  yyyy', { locale: this.locale });
  }


  formatHour(date: Date): string {
    return format(date, 'HH:mm')
  }

}
